import styled from 'styled-components';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const Title = styled(TextLayoutComponent.Title)`
  font-size: 18px;
`;

export const Timer = styled(Title)`
  color: green;
`;
